import isEmpty from 'lodash/isEmpty';
import { useFieldConfigsByEntity } from './fields';
import usePermissionCheck from './usePermissionCheck';
import { EntityType } from 'shared/constants/entityTypes';
import { PORTALVIEW_PERMISSION } from 'shared/constants/fields';

const fieldsToCheck = ['estimated_start_date', 'estimated_complete_date'];

// Settings & Enablement mechanics
export default function useRecurrenceParameters() {
  const [fieldConfigs] = useFieldConfigsByEntity(EntityType.TEST);
  const isSettingEnabled = usePermissionCheck(
    PORTALVIEW_PERMISSION.TEST_RECURRENCE_CREATE
  );
  const recurrenceFieldConfigs = fieldConfigs.filter((f) =>
    fieldsToCheck.includes(f.name)
  );
  const hasRequiredFields = !isEmpty(recurrenceFieldConfigs);
  const fieldShown = {
    globally: hasRequiredFields,
    onOrderRequest:
      hasRequiredFields &&
      recurrenceFieldConfigs.every((f) => Boolean(f.order_request_field)),
  };
  const isEnabled = isSettingEnabled && fieldShown.globally;
  const canCreate = isSettingEnabled && fieldShown.onOrderRequest;

  return {
    isEnabled,
    canCreate,
  };
}
